function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

export { arrRemove };
//# sourceMappingURL=arrRemove.js.map
